<template>
  <div
    v-if="loading || suggestions.length"
    class="chat-suggestions"
  >
    <div
      v-if="loading"
      class="loading-container"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="20"
        width="2"
      />
    </div>

    <v-row
      v-else
      class="chat-suggestions-row"
    >
      <v-col
        v-for="(suggestion, index) in suggestions"
        :key="suggestionKey(suggestion, index)"
        cols="12"
        sm="12"
        md="12"
        lg="12"
        class="suggestion-col"
      >
        <button
          class="suggestion-button"
          @click="$emit('select', suggestion)"
        >
          <span class="suggestion-icon-wrap">
            <v-icon size="16">
              mdi-plus
            </v-icon>
          </span>

          <span class="suggestion-text">
            {{ suggestionText(suggestion) }}
          </span>
        </button>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ChatSuggestions',

  dataStore: {
    assistantStore: 'AssistantStore'
  },

  computed: {
    suggestions () {
      return this.assistantStore.Suggestions?.Data || []
    },

    loading () {
      return Boolean(this.assistantStore.Suggestions?.Loading)
    }
  },

  methods: {
    suggestionText (suggestion) {
      return suggestion.displayContent || ''
    },

    suggestionKey (suggestion, index) {
      if (typeof suggestion === 'string') {
        return `${index}-${suggestion}`
      }

      return suggestion.id || `${index}-${this.suggestionText(suggestion)}`
    }
  }
}
</script>

<style scoped>
.chat-suggestions {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.loading-container {
  display: flex;
  justify-content: center;
  padding: 8px 0 12px;
}

.chat-suggestions-row {
  margin: 0 !important;
  width: 100%;
  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(440px, 100%), 1fr));
  gap: 14px;
}

.suggestion-col {
  width: 100% !important;
  max-width: 100% !important;
  padding: 0;
}

.suggestion-button {
  display: flex;
  align-items: stretch;
  gap: 0;

  width: 100%;
  min-height: 58px;
  padding: 0;

  border: 2px solid rgba(255, 255, 255, 0.98);
  border-radius: 8px;
  background: radial-gradient(39.15% 72.31% at 50.12% 27.69%, rgba(255, 255, 255, 0.64) 0%, rgba(255, 255, 255, 0) 100%) /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */;
  color: #041f30;

  cursor: pointer;
  text-align: left;
  font-family: 'Inter';
  font-size: 13px;
  font-weight: 400;
  line-height: 21px;

  box-shadow:
    0 16px 16px -16px #3D68D529,
    0 1px 6px -4px #3D68D5;

  transition:
    border-color 0.15s ease,
    transform 0.15s ease,
    box-shadow 0.15s ease;
}

.suggestion-icon-wrap {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 32px;
  align-self: stretch;
  width: 32px;
  border-radius: 6px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  background: linear-gradient(180deg, #dfe9fb 0%, #c9d9f4 100%);
}

.suggestion-text {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  padding: 0 14px;
  overflow-wrap: anywhere;
}

.suggestion-button:hover {
  border-color: #93de94;
  box-shadow:
    inset 0 0 0 1px rgba(255, 255, 255, 0.5),
    0 5px 14px rgba(21, 43, 74, 0.08);
}

.suggestion-button:active {
  transform: translateY(1px);
}

.suggestion-button:focus {
  outline: none;
  border-color: #ffffff;
}
</style>
